import { peso } from "../../lib/format";

export const cn = (...a) => a.filter(Boolean).join(" ");

export function Money({ value, className = "" }) {
  return <span className={cn("font-mono tabular", className)}>{peso(value)}</span>;
}

export function Btn({ as = "button", variant = "solid", className = "", children, ...rest }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors disabled:opacity-40 disabled:cursor-not-allowed active:scale-[.98] select-none";
  const variants = {
    solid: "bg-zinc-900 text-white hover:bg-zinc-800",
    emerald: "bg-emerald-600 text-white hover:bg-emerald-500",
    amber: "bg-amber-500 text-zinc-950 hover:bg-amber-400",
    indigo: "bg-indigo-600 text-white hover:bg-indigo-500",
    danger: "bg-rose-600 text-white hover:bg-rose-500",
    ghost: "bg-transparent hover:bg-zinc-500/10",
    outline: "border border-zinc-300 dark:border-zinc-700 hover:bg-zinc-500/10",
  };
  const Comp = as;
  return (
    <Comp className={cn(base, variants[variant], "px-4 py-2 text-sm", className)} {...rest}>
      {children}
    </Comp>
  );
}

export function Badge({ children, className = "" }) {
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold", className)}>
      {children}
    </span>
  );
}

export function Card({ className = "", children, ...rest }) {
  return (
    <div className={cn("rounded-2xl border shadow-sm", className)} {...rest}>
      {children}
    </div>
  );
}

export function Stat({ label, value, sub, accent = "text-zinc-900", testid }) {
  return (
    <div className="rounded-2xl border border-zinc-200 bg-white p-5 dark:border-zinc-800 dark:bg-zinc-900" data-testid={testid}>
      <div className="text-xs font-semibold uppercase tracking-wider text-zinc-400">{label}</div>
      <div className={cn("mt-1 font-head text-2xl font-extrabold", accent)}>{value}</div>
      {sub && <div className="mt-1 text-xs text-zinc-500">{sub}</div>}
    </div>
  );
}
